import React, { useState, useEffect, useRef } from 'react';
import humanReadableTime from '../../util/humanReadableTime';
import initializeCounter from '../../util/counterInitialization';
const CounterDown = ({ item, className, id }) => {
    const counterRef = useRef();

    const {
        time,
        date,
        GMT,
        finishText,
        settings: { zero, onlyHours, style },
        text: counterText,
    } = item.counter;

    let remainingTimes;

    if (time && date) {
        remainingTimes =
            Date.parse(`${date} ${time}  ${GMT ? 'GMT' + GMT : ''}`) -
            Date.now();
    }
    const [timeState, setTimeState] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        timer: remainingTimes,
    });

    useEffect(() => {
        const timer =
            remainingTimes > -3000 &&
            setInterval(() => {
                // @ts-ignore
                setTimeState({
                    ...timeState,
                    timer: remainingTimes,
                    ...humanReadableTime(timeState.timer, zero, onlyHours),
                });
                initializeCounter(timeState, item.id, remainingTimes);
            }, 1000);
        return () => clearInterval(timer);
    }, [remainingTimes]);

    let timesUnit = ['days', 'hours', 'minutes', 'seconds'];

    return (
        <div className={`${className} counter-${item.id}`} ref={counterRef}>
            {!(timeState.timer < -2000) ? (
                timesUnit.map((time, key) => {
                    return (
                        <React.Fragment key={key}>
                            <div className={`counter-wrapper`}>
                                <span
                                    className={`counter-value ${time}`}
                                ></span>
                                <span className={`counter-text`}>
                                    {counterText[time]}
                                </span>
                            </div>
                            {style !== 'none' && time !== 'seconds' && (
                                <div
                                    className={`counter--separator ${time}-separator`}
                                >
                                    {style === 'colon' && (
                                        <span className="counter--separator__colon">
                                            &#58;
                                        </span>
                                    )}
                                    {style === 'line' && (
                                        <span className="counter--separator__line"></span>
                                    )}
                                </div>
                            )}
                        </React.Fragment>
                    );
                })
            ) : (
                <span className="finish-text">{finishText}</span>
            )}
        </div>
    );
};

export default React.memo(CounterDown);
